import React, { useEffect, useState } from 'react'
import Header from './Header'
import axios from 'axios'
import { API } from './constant'

import { IoMdClose } from "react-icons/io";


const Questions = () => {

    const [updateTable, setupdateTable] = useState(false)

    //   =============get all paragraph details start =====================
    const [paragraphName, setparagraphName] = useState([])
    // console.log(paragraphName)

    useEffect(() => {
        axios.get(`${API}/add-paragraph/`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        })
            .then((res) => {
                // console.log(res.data.data)
                setparagraphName(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])


    //   =============get all paragraph details end =====================



    //============= ============find user role and give permission start ============================
    const [loggedinRole, setLoggedinRole] = useState("")
    useEffect(() => {
        axios.get(`${API}/login/logged-in-user`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                setLoggedinRole(res.data.data.role)
            })
            .catch((err) => {
                // console.log(err);
                if (err.response) {
                    // Handle invalid token
                    if (err.response.status === 401) {
                        localStorage.removeItem("token");
                        // history.push('/');
                        window.location.href = "/"
                    }
                    // Handle token expiration
                    else if (err.response.status === 302) {
                        window.location.href = "/"

                    }
                }
            });
    }, [])

    //============= ============find user role and give permission end ============================






    //================================== add question to the dynamic lexile score start ========================================
    const [selectedParagraph, setselectedParagraph] = useState("")
    const [questionName, setquestionName] = useState("")
    const [answerForQuestion, setanswerForQuestion] = useState("")
    const [Student_answer, setStudent_answer] = useState("")

    // console.log(selectedParagraph)

    const submitQuestion = async () => {
        const data = {
            paragraph_id: selectedParagraph,
            question_name: questionName,
            answer_for_question: answerForQuestion,
        }
        await axios.post(`${API}/question`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                console.log(res)
                alert(res.data.message)
                setupdateTable(!updateTable)
                clearfields()

            })
            .catch((err) => {
                console.log(err)
                alert(err.response.data.message)

            })
    }


    // ------------get all question start -----------------
    const [get_allQuestion, setget_allQuestion] = useState([])
    useEffect(() => {
        axios.get(`${API}/question`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        })
            .then((res) => {
                // console.log(res.data.data)
                setget_allQuestion(res.data.data)
            })
            .catch((err) => {
                console.log(err)
                alert(err.response.data.message)
            })
    }, [updateTable])
    // ------------get all question end -----------------

    //------------------ handle edit questionn start ------------
    const [QuestionEditModal, setQuestionEditModal] = useState(false)
    const [QuestionEditModalID, setQuestionEditModalID] = useState("")

    const [editquestionName, seteditquestionName] = useState("")
    const [editanswerForQuestion, seteditanswerForQuestion] = useState("")


    const handleEditQuestion = async (id) => {
        setQuestionEditModal(true)
        setQuestionEditModalID(id)
        await axios.get(`${API}/question/${id}`)
            .then((res) => {
                console.log(res)
                seteditquestionName(res.data.data.question_name)
                seteditanswerForQuestion(res.data.data.answer_for_question)
            })
            .catch((err) => {
                console.log(err)
            })
    }


    const hadleEditSubmit = async (id) => {
        const data = {
            question_name: editquestionName,
            answer_for_question: editanswerForQuestion,
            student_answer: Student_answer
        }

        await axios.put(`${API}/question/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                alert(res.data.message)
                setQuestionEditModal(false)
                setupdateTable(!updateTable)
            })
            .catch((err) => {
                console.log(err)
                alert(err.response.data.message)
            })
    }
    //------------------ handle edit questionn end ------------


    // ---------------handle delete question start ----------------
    const [deletePopUp, setdeletePopUp] = useState(false)
    const [deletePopUpID, setdeletePopUpID] = useState(false)

    const handleDeletePop = (id) => {
        setdeletePopUp(true)
        setdeletePopUpID(id)
    }

    const deleteQuestion = async (id) => {
        await axios.delete(`${API}/question/${id}`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                console.log(res)
                alert(res.data.message)
                setdeletePopUp(false)
                setupdateTable(!updateTable)
            })
            .catch((err) => {
                console.log(err)
            })
    }
    // ---------------handle delete question end ----------------

    //================================== add question to the dynamic lexile score end ========================================

    // clear fields  start 
    const clearfields = () => {
        setquestionName("")
        setanswerForQuestion("")
        seteditquestionName("")
        seteditanswerForQuestion("")
    }
    // clear fields  end


    return (
        <div>
            {
                loggedinRole && loggedinRole === "Admin" || loggedinRole === "Super Admin" ? (


                    <div className=''>
                        <Header />
                        <div className='mt-[70px] sm:mt-[150px] mx-[3px] sm:mx-[20px]'>

                            {/* dynamic lexile input start  */}

                            <div className=" w-full mx-auto my-[30px] ">
                                <div className='text-[12px] sm:text-[15px]  w-full px-[10px] py-[3px] bg-black/80 border-[1px] border-white text-white flex justify-between'>
                                    Paragraph Name:
                                    <div className='w-[40%]'>
                                        <select value={selectedParagraph} onChange={(e) => setselectedParagraph(e.target.value)} className='text-[12px] sm:text-[15px] bg-black/80 outline-none w-full'>
                                            <option value="">Select Your Paragraph</option>
                                            {
                                                paragraphName && paragraphName.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item._id}>{item.paragraph_name}</option>
                                                    )
                                                })

                                            }
                                        </select>
                                    </div>


                                </div>

                                <div className='w-full overflow-x-auto'>
                                    <table className="w-full">
                                        <thead>
                                            <tr className="bg-gray-100">
                                                <th className="text-[12px] sm:text-[15px] w-[60px] whitespace-nowrap text-center">Sr no.</th>
                                                <th className="text-[12px] sm:text-[15px] min-w-[180px]">Question Name</th>
                                                <th className="text-[12px] sm:text-[15px] min-w-[180px]">Answer for Question</th>
                                                {loggedinRole === "Super Admin" && (
                                                    <>
                                                        <th className="text-[12px] sm:text-[15px]">Edit</th>
                                                        <th className="text-[12px] sm:text-[15px]">Delete</th>
                                                    </>
                                                )}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loggedinRole === "Super Admin" && (
                                                <tr>
                                                    <td className="border px-4 py-2"></td>
                                                    <td className="border px-4 py-2">
                                                        <input
                                                            type="text"
                                                            className="w-full border rounded px-2 py-1 outline-none"
                                                            onChange={e => setquestionName(e.target.value)}
                                                            value={questionName}
                                                        />
                                                    </td>
                                                    <td className="border px-4 py-2">
                                                        <input
                                                            type="text"
                                                            className="w-full border rounded px-2 py-1 outline-none"
                                                            onChange={e => setanswerForQuestion(e.target.value)}
                                                            value={answerForQuestion}
                                                        />
                                                    </td>
                                                    <td className="border px-4 py-2" colSpan={2}>
                                                        <button
                                                            className="mt-4 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
                                                            onClick={() => submitQuestion()}
                                                        >
                                                            Submit
                                                        </button>
                                                    </td>
                                                </tr>
                                            )}


                                            {get_allQuestion && get_allQuestion
                                                .filter(item => selectedParagraph === "" || item.paragraph_id._id === `${selectedParagraph}`)
                                                .map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="w-[60px] border px-1 py-2 text-xs  text-center">
                                                            <input
                                                                type="text"
                                                                className="w-full border  outline-none "
                                                                readOnly
                                                                value={index + 1}
                                                            />
                                                        </td>
                                                        <td className="text-[12px] sm:text-[15px] border px-4 py-2 break-words min-w-[180px]">
                                                            <input
                                                                type="text"
                                                                className="w-full border rounded px-2 py-1 outline-none"
                                                                readOnly
                                                                value={item.question_name}
                                                            />
                                                        </td>
                                                        <td className="text-[12px] sm:text-[15px] border px-4 py-2 break-words min-w-[180px]">
                                                            <input
                                                                type="text"
                                                                className="w-full border rounded px-2 py-1 outline-none"
                                                                readOnly
                                                                value={item.answer_for_question}
                                                            />
                                                        </td>
                                                        {loggedinRole === "Super Admin" && (
                                                            <>
                                                                <td className="text-[12px] sm:text-[15px] border">
                                                                    <button onClick={() => handleEditQuestion(item._id)}>Edit</button>
                                                                </td>
                                                                <td className="text-[12px] sm:text-[15px] border">
                                                                    <button onClick={() => handleDeletePop(item._id)}>Delete</button>
                                                                </td>
                                                            </>
                                                        )}
                                                    </tr>
                                                ))}

                                        </tbody>
                                    </table>
                                </div>

                            </div>


                            {
                                QuestionEditModal && QuestionEditModal ? (
                                    <div>
                                        <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                            <div className='w-[80%]'>
                                                <div className='bg-[#6C7AE0] py-[10px] px-[10px] flex justify-between'><h5 className='text-white text-[25px]'>Edit Question</h5> <button onClick={() => setQuestionEditModal(false)}><IoMdClose size={30} color='white' /></button></div>
                                                {/* input field block start */}
                                                <div className='bg-white py-[10px]'>
                                                    <table className="w-full bg-white">
                                                        <thead>
                                                            <tr className="bg-gray-100">
                                                                <th className="border px-4 py-2">Quetion Name</th>
                                                                <th className="border px-4 py-2">Answer for Question</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr >
                                                                <td className="border px-4 py-2 w-[40%]">
                                                                    <input
                                                                        type="text"
                                                                        className="w-full border rounded px-2 py-1 outline-none"
                                                                        onChange={(e) => seteditquestionName(e.target.value)}
                                                                        value={editquestionName}
                                                                    />
                                                                </td>
                                                                <td className="border px-4 py-2 w-[40%]">
                                                                    <input
                                                                        type="text"
                                                                        className="w-full border rounded px-2 py-1 outline-none"
                                                                        onChange={(e) => seteditanswerForQuestion(e.target.value)}
                                                                        value={editanswerForQuestion}
                                                                    />
                                                                </td>
                                                            </tr>


                                                        </tbody>

                                                    </table>


                                                    <div className='flex justify-center'>
                                                        <button
                                                            className="mt-4 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
                                                            onClick={() => hadleEditSubmit(QuestionEditModalID)}
                                                        >
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>
                                                {/* input field block end */}
                                            </div>
                                        </div>
                                    </div>
                                ) : null
                            }


                            {
                                deletePopUp && deletePopUp ? (
                                    <div>
                                        <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                            <div className='w-[300px] bg-black rounded-md py-[20px]'>
                                                <div>
                                                    <h4 className='text-[12px] text-white font-semibold text-center'>Would you like to delete?</h4>
                                                </div>



                                                <div className='flex gap-6 justify-center my-[10px]'>
                                                    {/* <button onClick={editCalculateUtilization} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Calculate Total Utilization</button> */}
                                                    <button onClick={() => deleteQuestion(deletePopUpID)} className='bg-[#ec4848] px-[15px] py-[5px] text-white rounded-md' >Delete</button>
                                                    <button onClick={() => handleDeletePop(false)} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Cancel</button>
                                                </div>
                                            </div>
                                            {/* input field block end */}
                                        </div>
                                    </div>
                                ) : null


                            }

                            {/* dynamic lexile input end */}

                        </div>
                    </div>

                ) : (
                    <>
                        <p>You are not Authorized</p>
                    </>
                )
            }
        </div>
    )
}

export default Questions